import { envs } from '@/app/lib/config/envs';
import type { ButtonProps } from 'tailframes-components/components/button';
import { Button } from '@/app/ui/components/atoms/button';

interface Props extends Omit<ButtonProps, 'children'> {}

export default function TwitterFollowButton(props: Props) {
  return (
    <Button href={envs.twitterUrl} {...props}>
      Follow us on X
    </Button>
  );
}
